import React from 'react'
import { CFooter } from 'compat/coreui'

const DashFooter = () => {
  return (
    <CFooter fixed={false}>
      <div>
        <a href="#" target="_blank" rel="noopener noreferrer">JointPlug</a>
        <span className="ml-1">&copy; 2020 JointPlug.</span>
      </div>
    </CFooter>
  )
}

export default DashFooter;
